/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';

type Props = {
  positions?: Array<*>,
  renderPosition: (pos: Object) => React.Node
};

const defaultProps = {
  positions: []
};

const Wrapper = styled.div({
  overflow: 'hidden',
  position: 'relative'
});

function LineUpTable({ positions, renderPosition }: Props) {
  return <Wrapper>{positions.map((pos, i) => renderPosition(pos, i))}</Wrapper>;
}

LineUpTable.defaultProps = defaultProps;

export default LineUpTable;
